// eslint-disable-next-line no-shadow
export enum AccountsPagePlans {
	FREE = 'Free',
	STARTER = 'Starter',
	PRO = 'Pro',
	MAX = 'Max',
}
